import { gql } from 'apollo-boost';
import { SearchItems, Content } from './types';

export const buycontent = gql`
	mutation buyContent($paymentId: String!, $paymentName: String!) {
		buyContent(paymentId: $paymentId, paymentName: $paymentName)
	}
`;
export const updateContentBuy = gql`
	mutation updateContent($bookingid: Int!, $status: String!) {
		updatePaymentStatus(bookingid: $bookingid, status: $status)
	}
`;

export const mutateUploadContent = gql`
	mutation mutateUploadContent($file: Upload!) {
		uploadContentFile(file: $file) {
			fileName
			path
			resourceInfoPvid
		}
	}
`;

export const mutatePreviewContent = gql`
	mutation uploadContentPreviewFile($file: Upload!) {
		uploadContentPreviewFile(file: $file) {
			fileName
			path
			resourceInfoPvid
		}
	}
`;

export const toggleFavourite = gql`
	mutation toggleFav($contentid: String!) {
		setFavroite(contentid: $contentid) {
			status
			msg
		}
	}
`;

export const ADD_TO_FAVOURITE = gql`
	mutation addFavouriteContent($contentId: String!) {
		addFavouriteContent(contentId: $contentId)
	}
`;

export const GET_FAVOURITE_CONTENTS = gql`
  mutation getFavouriteItems($sort: String, $page: Int, $limit: Int){
		getFavouriteItems(sort: $sort, page: $page, limit: $limit){
      ${SearchItems}
		}
	}
`;

export const mutationAddContent = gql`
	mutation addContent(
		$title: String!
		$description: String!
		$tags: String!
		$purchaseLimit: Int
		$previewFile: String!
		$subjectId: String!
		$currency: String!
		$tiers: [AddContentTiers!]!
	) {
		addContent(
			title: $title
			description: $description
			tags: $tags
			purchaseLimit: $purchaseLimit
			previewFile: $previewFile
			subjectId: $subjectId
			currency: $currency
			tiers: $tiers
		) {
			pvid
			createdAt
		}
	}
`;

export const mutationAddContentReview = gql`
	mutation addReview($contentId: String!, $rating: Float!, $title: String!, $content: String!) {
		addReview(contentId: $contentId, rating: $rating, title: $title, content: $content) {
			pvid
			reviewTitle
			reviewContent
			authorName
			authorPicture
			createdAt
		}
	}
`;
export const GET_CONTENTS = gql`
	mutation getAllForPublic($querySearch: ContentSearch, $sort: String, $page: Int, $limit: Int, $fromWhere: String) {
		getAllForPublic(querySearch: $querySearch, sort: $sort, page: $page, limit: $limit, fromWhere: $fromWhere) {
		  ${SearchItems}
		}
	}
`;

export const GET_PUBLIC_CONTENT_BY_ID = gql`
mutation getContentItemPublic($id: String!) {
	getContentItemPublic(contentId: $id){
    ${Content}
	}
}`;

export const GET_CONTENT_BY_ID = gql`
	query GET_CONTENT_BY_ID($id: String, $country: String!) {
		getContentById(id: $id, country: $country) {
			pvid
			title
			description
			price
			commission
			earnings
			favourite
			purchaseLimit
			tutor {
				pvid
				email
				country
				firstName
				lastName
				phone
				address
				profileImage
			}
			resource {
				awsPath
				fileName
				relativePath
				mimeType
				encoding
				durationSecs
			}
			previewsData {
				awsPath
				fileName
				relativePath
				mimeType
				encoding
				durationSecs
			}
			reviews {
				pvid
				reviewTitle
				reviewContent
				authorName
				authorPicture
				createdAt
			}
			subjectInfo {
				pvid
				subject
			}
			createdAt
			numberOfDownloads
		}
	}
`;
export const MUTATION_SEARCH_CONTENTS = gql`
	mutation MUTATION_SEARCH_CONTENTS(
		$keywords: String!
		$price_range: PriceRange!
		$recently: Float!
		$alphabet: Float!
		$subjects: Float!
	) {
		searchContent(keywords: $keywords, price_range: $price_range, recently: $recently, alphabet: $alphabet, subjects: $subjects) {
			pvid
			title
			description
			price
			commission
			earnings
			purchaseLimit
			tutor {
				pvid
				email
				country
				firstName
				lastName
				phone
				address
				profileImage
			}
			resource {
				awsPath
				fileName
				relativePath
				mimeType
				encoding
				durationSecs
			}
			reviews {
				pvid
				reviewTitle
				reviewContent
				authorName
				authorPicture
				createdAt
			}
			subjectInfo {
				pvid
				subject
			}
			createdAt
			numberOfDownloads
		}
	}
`;

export const getDashboardData = gql`
	query GET_DASHBOARD_DATA {
		getDashboardData {
			buy {
				title
				datePublished
				name
				AWSpath
				pvid
			}
			buy2 {
				title
				datePublished
			}
			totalviews
			contentsold
			totalearning
			viewinc
			contentsoldInc
			earninc
			charts
		}
	}
`;

export const GET_EARNING_STATS = gql`
	mutation getEarningStats($startDate: Date, $endDate: Date) {
		getEarningStats(startDate: $startDate, endDate: $endDate) {
			currency
			result {
				year
				week
				earning
			}
		}
	}
`;

export const GET_PURCHASE_STATS = gql`
	mutation getPurchaseStats($startDate: Date, $endDate: Date) {
		getPurchaseStats(startDate: $startDate, endDate: $endDate) {
			year
			week
			count
		}
	}
`;

export const GET_TOTAL_EARNINGS = gql`
	mutation getTotalEarning {
		getTotalEarning {
			totalEarning
			currency
		}
	}
`;

export const GET_USER_PAID_CONTENT = gql`
mutation userGetHisPaidContent($page: Int, $limit: Int){
	userGetHisPaidContent(page: $page, limit: $limit){
		total
    count
    pagination{
      next{
        page
        limit
      }
      prev{
        page
        limit
      }
    }
    data{
      id
      title
      description
      price
      commission
      earnings
      createdAt
      resource{
        pvid
        path
        mimeType
      }
      content{
        id
        owner
        title
        description
        currency
      }
    }
	}
}
`;

export const GET_USER_CONTENTS = gql`
  mutation userGetHisContentItems($keywords: String!, $priceRange: PriceRange!, $subjects: Float!, $sort: String, $page: Int, $limit: Int){
		userGetHisContentItems(querySearch: {keywords: $keywords, price_range: $priceRange, subjects: $subjects}, sort: $sort, page: $page, limit: $limit){
      ${SearchItems}
		}
	}
`;

export const GET_TOTAL_VIEWS = gql`
	mutation getTotalViews {
		getTotalViews
	}
`;

export const GET_NO_OF_SALES = gql`
	mutation getNumberOfSales {
		getNumberOfSales
	}
`;

export const DELETE_CONTENT_ITEM = gql`
	mutation deleteContentItem($contentId: String!) {
		deleteContentItem(contentId: $contentId)
	}
`;

export const GET_CONTENT_ITEM_BY_ID = gql`
 mutation getContentForOwner($contentId: String!){
	getContentForOwner(contentId: $contentId){
		${Content}
	}
 }
`;
export const GET_CONTENT_PRICE = gql`
	mutation getProductsPrice($paymentName: String, $products: [String!]!) {
		getProductsPrice(paymentName: $paymentName, products: $products)
	}
`;
export const BUY_CONTENT = gql`
	mutation buyContent($paymentId: String!, $paymentName: String!) {
		buyContent(paymentId: $paymentId, paymentName: $paymentName)
	}
`;

export const UPDATE_CONTENT_ITEM = gql`
	mutation updateContentItem(
		$contentId: String!
		$title: String
		$description: String
		$tags: String
		$contentFile: String
		$purchaseLimit: Int
		$previewFile: String
		$price: Int
		$commission: Int
		$earnings: Int
		$subjectId: String
		$currency: String
	) {
		updateContentItem(
			contentId: $contentId
			title: $title
			description: $description
			tags: $tags
			contentFile: $contentFile
			purchaseLimit: $purchaseLimit
			previewFile: $previewFile
			price: $price
			commission: $commission
			earnings: $earnings
			subjectId: $subjectId
			currency: $currency
		)
	}
`;

export const GET_BOOSTED_CONTENT = gql`
	mutation getHomePageBoostedContent {
		getHomePageBoostedContent {
			pvid
			title
			description
			price
			commission
			earnings
			purchaseLimit
			tags
			numberOfViews
			numberOfReviews
			numberOfSales
			currency
			publish
			removeReason
			createdAt
			tutor {
				firstName
				lastName
				profileImage
			}
			contentResPreview {
				path
			}
		}
	}
`;


export const USER_DOWNLOAD_CONTENT = gql`
	mutation userDownloadContent($contentId: String!) {
		userDownloadContent(contentId: $contentId)
	}
`


export const GET_POPULAR_TAGS = gql`
	mutation getPopularTags {
		getPopulareTags{
    		tag
    		count
  		}
	}
`

export const GET_CONTENT_TIERS_PUBLIC = gql`
	mutation getContentTiersPublic($contentId: String!) {
  getContentTiersForPublic(contentId: $contentId){
    id
    title
    description
    price
    commission
    earnings
    createdAt
    resource{
      pvid
      mimeType
	  path
    }
  }
}
`


export const GET_CONTENT_TIERS_PRIVATE = gql`
	mutation getContentTiersForOwner($contentId: String!) {
		  getContentTiersForOwner(contentId: $contentId){
			id
    title
    description
    price
    commission
    earnings
    createdAt
    resource{
      pvid
      mimeType
      path
    }
  }
		  
	}
`


export const ADD_TIERS_TO_CONTENT = gql`
	mutation addTiersToContent(
		$contentId: String!,
		$title: String!,
		$description: String,
		$price: Float!,
		$commission: Float,
		$earnings: Float,
		$resourceId: String
	) {
		addTiersToContent(
			contentId: $contentId,
			title: $title,
			description: $description,
			price: $price,
			commission: $commission,
			earnings: $earnings,
			resourceId: $resourceId
		)
	}
`

export const DELETE_TIERS_FROM_CONTENT = gql`
	mutation deleteTierContent( $tierId: String!) {
		deleteTierContent(tierId: $tierId)
	}
`